import { render, staticRenderFns } from "./WorkRequestExport.vue?vue&type=template&id=4e157934&"
import script from "./WorkRequestExport.vue?vue&type=script&lang=ts&"
export * from "./WorkRequestExport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports